<div class="tw-p-[3px] tw-relative">
  <span [class]="trackClasses()">
    <input
      type="checkbox"
      role="switch"
      [id]="inputId"
      [checked]="selected()"
      [attr.aria-disabled]="disabled"
      [attr.aria-labelledby]="ariaLabelledBy() ?? null"
      [attr.aria-describedby]="ariaDescribedBy() ?? null"
      (change)="onInputChange($event)"
      class="tw-sr-only tw-absolute tw-size-full"
    />
    <span [class]="thumbClasses()">
      <bit-icon [class]="checkIndicatorClasses()" name="bwi-check"></bit-icon>
    </span>
  </span>
</div>
